import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';

@Component({
  selector: 'sm-assign-job-for-members',
  templateUrl: './assign-job-for-members.component.html',
  styleUrls: ['./assign-job-for-members.component.scss']
})
export class AssignJobForMembersComponent implements OnInit, OnDestroy {


  public inventoryData:any = {}
  public loader: boolean = false;
  private _apiSubscription: Subscription = new Subscription();
  public assetList: any[] = []; 
  inventoryTemplateData: any[] = [];
  selectedTemplateData: any = []
  public page: number = 1;
  datalength!: number
  public fileName: string = '';
  public removable: boolean = true;
  toShowTemplate: boolean = true
  editMode: boolean = false
  employeeList:any = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private loaderService: LoaderServiceService
  ) {}
  ngOnInit(): void {
    let data = this.parentData.data;
    console.log(data);
    
    
    this._apiService.getEmployeeListWithAssignment(data.entityHash)

 
    ////////////////////


    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      
       if(res.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_LIST_WITH_ASSIGNMENT){
       this.employeeList = []
       if(res.result){
        res.result.forEach((element:any) => {
          if(element.isExEmployee != 1){
            if(element.assigned_slots){
              element.assigned_slots = typeof element.assigned_slots == 'string' ? JSON.parse(element.assigned_slots) : element.assigned_slots
              element.formatted_assigned_slots = this.getUniqueTimeRangesWithCount(element.assigned_slots)
            }
            this.employeeList.push(element)
          }
        });
       }
        console.log(this.employeeList);
        
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER){
        if (res.result) {
          this.parentData.ref.closeAll();
        } 
        
      }
    });
  }


  onPost() {
   
    this.loaderService.showLoader = true
    let obj = { 
      memberHash: this.parentData.data.member_hash_id,
      entityHash: this.parentData.data.entityHash,
      assignToHash: this.employeeToAssign[0].employeeHashId,
      assignByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      attendanceHash:  this.parentData.data.hash_id,

     }
     
    this._apiService.assignEmployeeToMember(obj)
   
  }


  //image upload

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  removeAsset() {
    this.inventoryData.img_url = '';
    this.inventoryData.thumb_url = '';
    this.assetList = [];
  }

  ngOnDestroy(): void {
    // this._apiSubscription.unsubscribe()
    this.employeeList = []
    this.employeeToAssign = []
    this.page = 1
    this._apiSubscription.unsubscribe()
  }
  employeeToAssign:any = []
  selectEmployeeToAssign(item:any){
    this.employeeToAssign = []
    this.employeeList.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.employeeToAssign.push(item)

    // this.selectedTopicHashId = item.hash_id
    // this.selectedTopicName = item.topic_name
  }


  // selectEmployeeToAssign(item:any){
  //   this.employeeToAssign = {}

  //   this.employeeToAssign = item
  // }

  onSelectNext(){
    this.toShowTemplate = false

    this.inventoryData.item_name = this.selectedTemplateData[0].item_name
    this.inventoryData.item_desc = this.selectedTemplateData[0].item_desc
    this.inventoryData.qty_info = this.selectedTemplateData[0].quantity_info
    this.inventoryData.img_url =  this.selectedTemplateData[0].image_url
    this.inventoryData.thumb_url =  this.selectedTemplateData[0].image_thumb_url
    this.inventoryData.purchase_unit = this.inventoryData.current_stock = this.inventoryData.min_stock = null

    this.assetList = []
    if(this.selectedTemplateData[0].image_thumb_url && this.selectedTemplateData[0].image_thumb_url != 'null'){
      this.assetList.push({
        assetName: this.selectedTemplateData[0]?.image_thumb_url
          .split('/')
          .pop()
          .substring(this.selectedTemplateData[0].image_thumb_url.split('/').pop().lastIndexOf('_') + 1),
        url: this.selectedTemplateData[0]?.image_thumb_url,
      });
    }

  }

  back(){
    this.toShowTemplate=true

   
  }

  seeMore(){
    this.page +=  1;
    this._apiService.getInventoryItemTemplateList(this.page)
  }

  getUniqueTimeRangesWithCount(timeRanges: any[]): any[] {
  const map = new Map<string, any>();

  for (const range of timeRanges) {
    const key = `${range.start_time}|${range.end_time}`;
    if (map.has(key)) {
      map.get(key).count += 1;
    } else {
      map.set(key, {
        start_time: range.start_time,
        end_time: range.end_time,
        count: 1
      });
    }
  }

  return Array.from(map.values());
}

  
}


